import { GetCustomerQuery } from '@/types/graphql'

import Card from '@/components/Card'
import Stack from '@/components/Stack'
import { Body } from '@/components/Typography'

type Props = {
  customer: GetCustomerQuery['customer']
}

const SchedulingSection = ({ customer }: Props) => {
  return (
    <Card.Section
      actions={[{
        a11yLabel: "Change this customer's scheduling settings",
        label: 'Change',
        onAction: () => undefined
      }]}
      title='Scheduling'
    >
    </Card.Section>
  )
}

export default SchedulingSection
